import React, { useEffect, useState } from "react";
// import { ContactoRelleno } from "./DomicilioRelleno";
import EditIcon from "@mui/icons-material/Edit";

import request from "../../../Helpers/API";
import Swal from "sweetalert2";
import { ModalContactoNew } from "./ModalContactoNew";
import EmailIcon from '@mui/icons-material/Email';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import { ModalContactoEditarNew } from "./ModalContactoEditarNew";
import LocalPhoneIcon from '@mui/icons-material/LocalPhone';
import { useSelector } from "react-redux";

export const ContactoListScreen2 = ({ setLoading }) => {
    const { clienteselected, idcliente } = useSelector((store) => store.clientes);
    const [contactos, setContactos] = useState([]);
    const [tipocontactoselected, setTipoContactoSelected] = useState();
    const [orden, setOrden] = useState(-1);
    const openModal = (value, tipocontacto) => {
        setTipoContactoSelected(tipocontacto);
        var modal = document.getElementById("modal-contacto-new");
        modal.style.display = "block";
        setOrden(value);
    };
    const openModalEditar = (value, tipocontacto) => {
        // setTipoContactoSelected(tipocontacto);
        var modal = document.getElementById("modal-contacto");
        modal.style.display = "block";
        setOrden(value);
    };
    useEffect(() => {
        if (
            idcliente === undefined ||
            idcliente === null ||
            idcliente === 0 ||
            idcliente === "0" ||
            idcliente === "" ||
            idcliente === "-1" ||
            idcliente === "-1"
        ) {
            return;
        }
        setLoading(true);
        request
            .get(`ClientesDatosContacto/Listado?idcliente=${Number(idcliente)}`)
            .then((result) => {
                setLoading(false);
                setContactos(result);
            })
            .catch((error) => {
                setLoading(false);
                Swal.fire("Clientes", JSON.stringify(error), "error");
            });
    }, [idcliente]);
    if (
        idcliente === undefined ||
        idcliente === null ||
        idcliente === 0 ||
        idcliente === "0" ||
        idcliente === "" ||
        idcliente === "-1" ||
        idcliente === "-1"
    ) {
        return <div>Favor de seleccionar un cliente</div>;
    }
    const capitalizeWords = (str) => {
        return str ? str.toLowerCase().replace(/\b\w/g, (char) => char.toUpperCase()) : "";
    };
    return (
        <>
            <div className="clientes-contacto-header">
                <ModalContactoNew setContactos={setContactos} orden={orden} mediocontacto={tipocontactoselected} />
                <ModalContactoEditarNew setContactos={setContactos} orden={orden} mediocontacto={tipocontactoselected} />
                <div className="clientes-contacto-titulo">{capitalizeWords(clienteselected)}</div>
                <div
                    className="clientes-contacto-correo"
                    onClick={() => openModal(0, "C")}
                >
                    <EmailIcon />
                    Correo
                </div>
                <div
                    className="clientes-contacto-llamada"
                    onClick={() => openModal(0, "T")}
                >
                    <LocalPhoneIcon />
                    Llamadas
                </div>
                <div
                    className="clientes-contacto-whatsapp"
                    onClick={() => openModal(0, "W")}
                >
                    <WhatsAppIcon />
                    WhatsApp
                </div>
            </div>
            <div className="clientes-contacto-container scroll-4">
                {contactos === undefined ||
                    contactos === null ||
                    contactos.length === 0 ? (
                    <div className="no-data " xx>
                        Sin datos registrados
                    </div>
                ) : (
                    <table cellPadding={0} cellSpacing={0}>
                        <thead>
                            <tr>
                                <th>Medio de Contacto</th>
                                <th>Tipo de Contacto</th>
                                <th>Valor</th>
                                <th></th>
                            </tr>
                        </thead>
                        <tbody>
                            {contactos.filter((item) => {
                                if (tipocontactoselected === "W") return item.medio_contacto.toUpperCase() === "WHATSAPP";
                                if (tipocontactoselected === "C") return item.medio_contacto.toUpperCase() === "CORREO";
                                if (tipocontactoselected === "T") return item.medio_contacto.toUpperCase() === "TELEFONO";
                                return true; // si no hay filtro, se muestran todos
                            })
                                .map((item) => (
                                    <tr>
                                        <td>{capitalizeWords(item.medio_contacto)}</td>
                                        <td>{capitalizeWords(item.tipo_contacto)}</td>
                                        <td>{item.valor}</td>
                                        <td>
                                            <div
                                                className="button-editar"
                                                onClick={() => openModalEditar(item.orden)}
                                            >
                                                <EditIcon />
                                                Editar
                                            </div>
                                        </td>
                                    </tr>
                                ))}
                        </tbody>
                    </table>
                )}
            </div>
        </>
    );
};
